import React, { useEffect } from "react";
import { TextControl, Button, TextareaControl } from "@wordpress/components";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";

import { SmartForm } from "../SmartForm";

const FormSetupModal = ({
  open,
  setOpen,
  formApi,
}: {
  open: boolean;
  setOpen: (b: boolean) => void;
  formApi: SmartForm;
}) => {
  const [configuration, setConfiguration] = React.useState(
    () => formApi.configuration
  );

  useEffect(() => {
    setConfiguration(formApi.configuration);
  }, [formApi]);

  const handleCloseModal = () => {
    formApi.setConfiguration(configuration);
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="form_mail_settings"
      >
        <DialogTitle id="form_mail_settings">Mail Settings</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Here you can modify the settings for sending and receiving the email
            as well as the body of the message in a very flexible way.
          </DialogContentText>
          <DialogContentText>
            In the following fields, you can use these mail-tags:
            <br />
            {formApi &&
              formApi.fields.map((field) => (
                <span key={field.blockId + "#" + field.smartProp}>[{field.name}] </span>
              ))}
          </DialogContentText>
          <TextControl
            value={configuration.emailTo}
            onChange={(value: string) =>
              setConfiguration({
                ...configuration,
                emailTo: value,
              })
            }
            autoFocus
            id="mail_to"
            label="Email To"
            type="email"
            fullWidth
          />
          <TextControl
            value={configuration.subject}
            onChange={(value: string) =>
              setConfiguration({
                ...configuration,
                subject: value,
              })
            }
            id="mail_subject"
            label="Subject"
            type="text"
            fullWidth
          />
          <TextareaControl
            value={configuration.headers}
            onChange={(value: string) =>
              setConfiguration({
                ...configuration,
                headers: value,
              })
            }
            id="mail_headers"
            label={"Additional headers"}
          />
          <TextareaControl
            value={configuration.message}
            onChange={(value: string) =>
              setConfiguration({
                ...configuration,
                message: value,
              })
            }
            id="mail_message"
            label={"Message Body"}
            rows={8}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} isPrimary={true}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FormSetupModal;
